import {
  actionCreator,
  BUSINESS_NAME_API,
  checkHttpStatus,
  handleLoginRedirect,
  jsonApiHeader,
  loginActionTypes,
  SAVE_LOGIN_QUESTIONS,
  POST_RESET_SECURITY_QUESTION,
  GET_SECURITY_QUESTIONS,
  SECURITY_QUESTIONS_POST_API,
  securityQuestionsActionType } from './../constants/ApiConstants';
import GlobalVariables, {showSuccessMessage} from '../../../actions/utilAction';

import {  AgencyDashboardActionTypes } from './../../Dashboards/constants/ApiConstants';
import {  PatientDashboardActionTypes} from './../../PatientPortal/containers/dashboard/constants/ApiConstants';
/**
 * @todo check business name
 * @desc get subdomain name from url and take it as business name.
 *       Check business name and return message if business name not subscribed.
 *        /VerifyBusinessName?BusinessName
 */
export function checkBusinessName(businessName) {
  return (dispatch) => {
    dispatch(actionCreator(loginActionTypes.check_business_name.REQUEST));
    fetch(`${BUSINESS_NAME_API}?BusinessName=${businessName}`, {
      method: 'get',
      headers: jsonApiHeader(null, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode === 200) {
          dispatch(actionCreator(loginActionTypes.check_business_name.SUCCESS, { access_token: response.data.businessToken, businessCheckMessage: null, organizationDetails: response.data.organization }));
        }
        if (response.statusCode === 401) {
          dispatch(actionCreator(loginActionTypes.check_business_name.SUCCESS, { access_token: null, businessCheckMessage: response.message }));
        }
      }).catch(function(error) {
        console.log('error logs: ', error);
      });
  };
}

export function loginAction(authData, businessNameCheck) {
  return (dispatch) => {
    dispatch(actionCreator(loginActionTypes.post_login.REQUEST));
    fetch(`${SECURITY_QUESTIONS_POST_API}`, {
      method: 'post',
      body: JSON.stringify(authData),
      headers: {
        'Content-Type': 'application/json',
        'businessToken': businessNameCheck,
      },
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.data.users3.userRoles.roleName === 'Client') {
          let currentLocationId = response.data.locationID;
          GlobalVariables.CurrentLocationId = currentLocationId;
          dispatch(actionCreator(loginActionTypes.post_login.SUCCESS, { errorMessage: null, currentLocationId: currentLocationId, access_token: response.access_token, loginUserInfo: response.data }));
          dispatch(actionCreator(PatientDashboardActionTypes.get_CheckUserPasswordStatus.SUCCESS, {passwordExpiryStatus: response.passwordExpiryStatus}));
          //handleLoginRedirect(response.access_token, authData, '/client-dashboard');          
          handleLoginRedirect(response.access_token, authData, '/my-profile');          

        } else {
          let userPermission = response.userPermission;
          let currentLocationId = response.data.staffLocation[0].locationID;
          GlobalVariables.CurrentLocationId = currentLocationId;
          dispatch(actionCreator(loginActionTypes.post_login.SUCCESS, { errorMessage: null, currentLocationId: currentLocationId, access_token: response.access_token, loginUserInfo: response.data, userPermission: userPermission, appConfigurations: response.appConfigurations, isOnlyForAgency: true, userLocationList: response.userLocations }));
          dispatch(actionCreator(AgencyDashboardActionTypes.get_CheckUserPasswordStatus.SUCCESS, { passwordExpiryStatus: response.passwordExpiryStatus}));
          handleLoginRedirect(response.access_token, authData, '/dashboard');
        }
      }).catch(function(error) {
        // console.log('error logs: ', error);
        let errorMessage = 'Invalid username or password';
        dispatch(actionCreator(loginActionTypes.post_login.FAILURE, { errorMessage: errorMessage, access_token: null, loginUserInfo: null }));
      });
  };
}
export function saveLoginQuestions(authData, businessNameCheck) {
  return (dispatch) => {
    dispatch(actionCreator(securityQuestionsActionType.save_login_questions.REQUEST));
    fetch(`${SAVE_LOGIN_QUESTIONS}`, {
      method: 'post',
      body: JSON.stringify(authData),
      headers: {
        'Content-Type': 'application/json',
        'businessToken': businessNameCheck,
      },
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if ((response.statusCode >= 400 && response.statusCode < 500) && response.message) {
          let errorMessage = response.message;
          dispatch(actionCreator(securityQuestionsActionType.save_login_questions.FAILURE, { response: response, errorMessage: errorMessage }));
        } else {
          let errorMessage = response.message;
          dispatch(actionCreator(securityQuestionsActionType.save_login_questions.SUCCESS, { response: response, errorMessage: errorMessage }));
          if (response.data.users3.userRoles.roleName === 'Client') {
            let currentLocationId = response.data.locationID;
            GlobalVariables.CurrentLocationId = currentLocationId;
            dispatch(actionCreator(loginActionTypes.post_login.SUCCESS, { errorMessage: null, currentLocationId: currentLocationId, access_token: response.access_token, loginUserInfo: response.data }));
            dispatch(actionCreator(PatientDashboardActionTypes.get_CheckUserPasswordStatus.SUCCESS, {passwordExpiryStatus: response.passwordExpiryStatus}));
            //handleLoginRedirect(response.access_token, authData, '/client-dashboard');
            handleLoginRedirect(response.access_token, authData, '/my-profile');
          } else {
            let userPermission = response.userPermission;
            let currentLocationId = response.data.staffLocation[0].locationID;
            GlobalVariables.CurrentLocationId = currentLocationId;
            dispatch(actionCreator(loginActionTypes.post_login.SUCCESS, { errorMessage: null, currentLocationId: currentLocationId, access_token: response.access_token, loginUserInfo: response.data, userPermission: userPermission, appConfigurations: response.appConfigurations, isOnlyForAgency: true, userLocationList: response.userLocations }));
            dispatch(actionCreator(AgencyDashboardActionTypes.get_CheckUserPasswordStatus.SUCCESS, { passwordExpiryStatus: response.passwordExpiryStatus}));
            handleLoginRedirect(response.access_token, authData, '/dashboard');
          }
        }
      }).catch(function(error) {
        // console.log('error logs: ', error);
        let errorMessage = 'Invalid username or password';
        dispatch(actionCreator(securityQuestionsActionType.save_login_questions.FAILURE, { response: error.response, errorMessage: errorMessage }));
        dispatch(actionCreator(loginActionTypes.post_login.FAILURE, { errorMessage: errorMessage, access_token: null, loginUserInfo: null }));
      });
  };
}

export const resetSecurityQuestion = (authData, businessNameCheck) => {
  // console.log('action--------', authData);
  return (dispatch, getState) => {
    dispatch(actionCreator(securityQuestionsActionType.post_reset_security_question.REQUEST));
    fetch(`${POST_RESET_SECURITY_QUESTION}`, {
      method: 'POST',
      body: JSON.stringify(authData),
      headers: {
        'Content-Type': 'application/json',
        'businessToken': businessNameCheck,
      },
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(securityQuestionsActionType.post_reset_security_question.SUCCESS, response));
        showSuccessMessage(response.message);
      })
      .catch(function(error) {
        console.log('error:put_reset_security_question ', error);
      });
  };
};

export const getResetSecurityQuestion = (authData, businessNameCheck) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(securityQuestionsActionType.get_reset_security_question.REQUEST));
    fetch(`${GET_SECURITY_QUESTIONS}`, {
      method: 'post',
      body: JSON.stringify(authData),
      headers: {
        'Content-Type': 'application/json',
        'businessToken': businessNameCheck,
      },    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(securityQuestionsActionType.get_reset_security_question.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error: get_app_config', error);
      });
  };
};

export function removeErrorMessage(){
  return (dispatch) => {
    dispatch(actionCreator(securityQuestionsActionType.remove_error_message.SUCCESS));
  }
}






// WEBPACK FOOTER //
// ./src/modules/SecurityQuestions/actions/SecurityQuestionsActions.js